// UMD export
// Typescript UMD module compile option does not support globals
// Typescript module compile also does not work with namespaces
// Since we use SmartVideo namespace (internal module) and that creates global SmartVideo object,
// we need to make that SmartVideo global visible to loaders
// Hopefully one day TS module compile will support globals, at which point we can stop using namespace
// and do straight external modules
var SmartVideo;
if (typeof define === 'function' && define.amd) {
    define('SmartVideo', [], SmartVideo);
}
else if (typeof module !== 'undefined' && module.exports && window.module !== module) {
    module.exports = SmartVideo;
}
else {
    window.SmartVideo = SmartVideo;
}